// Dependencies
import CasesSlider  from 'slider';
import CasesFilters from 'filters';

// Photo Swipe
import PhotoSwipe   from 'vendors/pswp';
import PhotoSwipeUI from 'vendors/pswp.ui';


class Cases {
  /**
   * Constructor: Hero Constructor.
   */
  constructor(options = {}) {
    // Context
    this._context = options.context || document;

    // Root
    this._root = this._context.querySelector('[type="cases"]');
    
    // Elements
    this._cards   = [...this._root.querySelectorAll('.case-card')];
    this._grid    = this._root.querySelector('.cases__grid');
    this._nav     = this._root.querySelector('.cases__nav');
    this._prev    = this._root.querySelector('.cases__prev');
    this._next    = this._root.querySelector('.cases__next');
    this._message = this._root.querySelector('.cases__message'); 
    this._filters = this._root.querySelector('.cases__filters');
    this._pswp    = document.querySelectorAll('.pswp')[0];

    if (this._filters) {
      this._selects = [...this._filters.querySelectorAll('select')];
    }

    // PSWP Options
    this.options = {
      history: false,
      fullscreenEl: false,
      shareEl: false,
    };

    // Slider Class
    this.Slider = new CasesSlider({
      root   : this._root,
      grid   : this._grid,
      nodes  : this._cards,
      nav    : this._nav,
      buttons: {
        prev: this._prev,
        next: this._next,
      },
    });

    // Filters Class
    this.Filters= new CasesFilters({
      root   : this._root,
      grid   : this._grid,
      filters: this._filters,
      selects: this._selects,
      message: this._message,
    });

    // Create Events
    this._onClick = this.onClick.bind(this);

    // Attach Events
    this.attach();

    // Listen Events
    window.Emitter.on('cases-updated', () => {
      // Attach Events
      this.attach();

      // Update Slider
      this.Slider.update();
    });

    window.Emitter.on('cases-filtering', () => {
      // Detach Events
      this.detach();
    });
  }


  /**
   * Attach Events
   */
  attach() {
    // Cards
    this._cards = [...this._root.querySelectorAll('.case-card')];

    // Cards Events
    this._cards.map((card) => {
      card.addEventListener('click', this._onClick);
    });
  }


  /**
   * Detach Events
   */
  detach() {
    this._cards = [...this._root.querySelectorAll('.case-card')];

    // Cards Events
    this._cards.map((card) => {
      card.removeEventListener('click', this._onClick);
    });
  }


  /**
   * On Card Click
   */
  onClick(e) {
    e.preventDefault();

    // Create Items Object
    const items  = [];
    const images = [...e.currentTarget.querySelectorAll('.card__related span')];

    images.map((image) => {
      items.push({
        src   : image.dataset.src,
        w     : parseInt(image.dataset.width),
        h     : parseInt(image.dataset.height),
        title : image.dataset.caption,
      });
    });

    this.PSWP = new PhotoSwipe(this._pswp, PhotoSwipeUI, items, this.options);
    this.PSWP.init();
  }


  /**
   * Resize: Resize the Cases.
   */
  resize() {
    this.Slider.resize();
  }
}

export default Cases;


// WEBPACK FOOTER //
// ./src/js/layouts/cases/index.js